export default __webpack_public_path__ + "static/media/E3AFB072-AC4E-4C06-9B8D-FC0D1668E8FD_1_105_c.9f834f0d.jpeg";